const calculateLevenshteinDistance = (source, target) => {
    const sourceLength = source.length;
    const targetLength = target.length;

    // Create a matrix to store the Levenshtein distances
    const distances = new Array(sourceLength + 1);
    for (let i = 0; i <= sourceLength; i++) {
        distances[i] = new Array(targetLength + 1);
        distances[i][0] = i;
    }
    for (let j = 0; j <= targetLength; j++) {
        distances[0][j] = j;
    }

    // Calculate the Levenshtein distance
    for (let i = 1; i <= sourceLength; i++) {
        for (let j = 1; j <= targetLength; j++) {
            const cost = source[i - 1] === target[j - 1] ? 0 : 1;

            distances[i][j] = Math.min(
                distances[i - 1][j] + 1,    // Deletion
                distances[i][j - 1] + 1,    // Insertion
                distances[i - 1][j - 1] + cost  // Substitution
            );
        }
    }

    // Return the Levenshtein distance between the two strings
    return distances[sourceLength][targetLength];
}

export { calculateLevenshteinDistance }